/**
 * Товары лавки: русский.
 *
 * ⚠️ ОТДЕЛЬНЫМ ФАЙЛОМ ПО ТОЙ ЖЕ ПРИЧИНЕ, ЧТО И РЫБА (см. species-north-ru.ts):
 * витрина выросла со ста восьмидесяти строк, и держать их в общем словаре
 * значит листать через всю лавку ради надписи на кнопке.
 *
 * ⚠️ ПЕРВЫЕ КЛЮЧИ — НЕ ИМЕНА, А ЧАСТИ ОПИСАНИЯ («тест до», «фрикцион до»).
 * Они лежат здесь же намеренно: из них собирается строка под названием
 * предмета (item-text.ts), и разъедься они с именами по разным файлам —
 * правка одного предмета пошла бы в два места.
 *
 * ⚠️ ОБЪЯВЛЕННОЕ ОТ РАБОЧЕГО ЗДЕСЬ НЕ ОТЛИЧАЕТСЯ, И ЭТО ВЕРНО. Имя предмета
 * не зависит от того, продаётся он уже или помечен «скоро»: метку ставит
 * лавка по каталогу, а не словарь.
 */
export const ТОВАРЫ_RU: Record<string, string> = {
  // ── было в общем словаре ──
  'item.test': 'тест до',
  'item.drag': 'фрикцион до',
  'item.dive': 'заглубление',
  'item.action_fast': 'быстрый строй',
  'item.action_medium': 'средний строй',
  'item.action_slow': 'медленный строй',
  'item.mat_mono': 'монофил',
  'item.mat_fluoro': 'флюорокарбон',
  'item.mat_braid': 'плетёнка',
  'item.rod_medium': 'Спиннинг «Медиум» 2,4 м',
  'item.rod_ultralight': 'Спиннинг «Ультралайт» 1,98 м',
  'item.rod_light': 'Спиннинг «Лайт» 2,13 м',
  'item.rod_heavy': 'Спиннинг «Хэви» 2,7 м',
  'item.reel_stock': 'Катушка 2500',
  'item.reel_3000': 'Катушка 3000',
  'item.reel_4000': 'Катушка 4000',
  'item.line_mono_024': 'Монофил 0,24 мм',
  'item.line_mono_030': 'Монофил 0,30 мм',
  'item.line_fluoro_022': 'Флюорокарбон 0,22 мм',
  'item.line_braid_014': 'Плетёнка 0,14 мм',
  'item.line_braid_020': 'Плетёнка 0,20 мм',
  'item.lure_spoon_18': 'Колебалка 18 г',
  'item.lure_spinner_8': 'Вертушка 8 г',
  'item.lure_wobbler_12': 'Воблер 12 г',
  'item.lure_wobbler_deep': 'Воблер глубинный 16 г',
  'item.lure_jig_14': 'Джиг 14 г',
  'item.lure_jig_24': 'Джиг 24 г',
  'item.lead_fluoro': 'Поводок флюорокарбон 0,20 мм',
  'item.lead_steel': 'Поводок стальной 12 кг',
  'item.hook_10': 'Крючок № 10',
  'item.hook_8': 'Крючок № 8',
  'item.hook_6': 'Крючок № 6',
  'item.hook_4': 'Крючок № 4',
  'item.bait_corn': 'Кукуруза',
  'item.bait_worm': 'Червь навозный',
  'item.bait_maggot': 'Опарыш',
  'item.bait_fry': 'Живец',
  'item.gb_basic': 'Прикормка базовая',
  'item.gb_aroma': 'Прикормка ароматизированная',
  'item.food_sandwich': 'Бутерброд',
  'item.food_tea': 'Термос с чаем',
  'item.food_stew': 'Тушёнка',
  'item.food_ration': 'Паёк на день',
  'item.keep_150': 'Садок на 150 рыб',
  'item.keep_250': 'Садок на 250 рыб',
  'item.keep_400': 'Садок на 400 рыб',
  'item.sonar_shore': 'Эхолот береговой',
  'item.sonar_far': 'Эхолот дальний',
  'item.boat_row': 'Лодка вёсельная',
  'item.boat_motor': 'Лодка моторная',
  'item.net_small': 'Подсачек малый',
  'item.net_big': 'Подсачек большой',
  'item.lamp_head': 'Фонарь налобный',
  'item.lamp_camp': 'Фонарь кемпинговый',
  'item.tent_solo': 'Палатка одноместная',
  'item.tent_duo': 'Палатка двухместная',
  'item.cloth_rain': 'Дождевик',
  'item.cloth_warm': 'Костюм тёплый',
  'item.gear_chair': 'Стул складной',
  'item.gear_box': 'Ящик рыболовный',
  'item.gear_thermos': 'Термос',
  'item.gear_scales': 'Весы',
  'item.gear_tape': 'Рулетка',
  'item.gear_stringer': 'Кукан',


  // ── удилища ──
  'item.rod_spin_ul_21': 'Спиннинг «Ультралайт» 2,10 м',
  'item.rod_spin_jig_27': 'Спиннинг джиговый 2,70 м',
  'item.rod_spin_twitch_21': 'Спиннинг твичинговый 2,10 м',
  'item.rod_spin_sea_30': 'Спиннинг тяжёлый 3,00 м',
  'item.rod_feeder_33': 'Фидер лёгкий 3,30 м',
  'item.rod_feeder_36': 'Фидер средний 3,60 м',
  'item.rod_feeder_39': 'Фидер тяжёлый 3,90 м',
  'item.rod_match_42': 'Удилище матчевое 4,20 м',
  'item.rod_bolo_50': 'Удилище болонское 5,00 м',
  'item.rod_pole_60': 'Удилище маховое 6,00 м',
  'item.rod_carp_36': 'Удилище карповое 3,60 м',
  'item.rod_fly_5': 'Удилище нахлыстовое 5 класса',
  'item.rod_fly_8': 'Удилище нахлыстовое 8 класса',
  'item.rod_tele_40': 'Удилище телескопическое 4,00 м',
  'item.rod_troll_24': 'Удилище троллинговое 2,40 м',
  'item.rod_ice': 'Удочка зимняя',

  // ── катушки ──
  'item.reel_1000': 'Катушка 1000',
  'item.reel_2000': 'Катушка 2000',
  'item.reel_5000': 'Катушка 5000',
  'item.reel_8000': 'Катушка 8000',
  'item.reel_baitrunner': 'Катушка с байтраннером',
  'item.reel_feeder': 'Катушка фидерная',
  'item.reel_rear_drag': 'Катушка с задним фрикционом',
  'item.reel_carp_big': 'Катушка карповая',
  'item.reel_multi': 'Мультипликатор',
  'item.reel_troll': 'Катушка троллинговая',
  'item.reel_fly': 'Катушка нахлыстовая',
  'item.reel_ice': 'Катушка зимняя',

  // ── леска ──
  'item.line_mono_016': 'Монофил 0,16 мм',
  'item.line_mono_020': 'Монофил 0,20 мм',
  'item.line_mono_028': 'Монофил 0,28 мм',
  'item.line_mono_035': 'Монофил 0,35 мм',
  'item.line_fluoro_018': 'Флюорокарбон 0,18 мм',
  'item.line_fluoro_028': 'Флюорокарбон 0,28 мм',
  'item.line_braid_010': 'Плетёнка 0,10 мм',
  'item.line_braid_025': 'Плетёнка 0,25 мм',
  'item.line_feeder_022': 'Леска фидерная 0,22 мм',
  'item.line_carp_030': 'Леска карповая 0,30 мм',
  'item.line_ice_012': 'Леска зимняя 0,12 мм',
  'item.line_shock': 'Шок-лидер',

  // ── поводки ──
  'item.lead_mono': 'Поводок монофильный 0,16 мм',
  'item.lead_titan': 'Поводок титановый 9 кг',
  'item.lead_tungsten': 'Поводок вольфрамовый 7 кг',
  'item.lead_kevlar': 'Поводок кевларовый 15 кг',
  'item.lead_carp': 'Поводок карповый плетёный',
  'item.lead_fly': 'Подлесок нахлыстовый',

  // ── крючки ──
  'item.hook_14': 'Крючок № 14',
  'item.hook_12': 'Крючок № 12',
  'item.hook_2': 'Крючок № 2',
  'item.hook_1_0': 'Крючок № 1/0',
  'item.hook_treble': 'Тройник',
  'item.hook_double': 'Двойник',
  'item.hook_offset': 'Крючок офсетный',
  'item.hook_carp': 'Крючок карповый',

  // ── приманки ──
  'item.lure_spoon_7': 'Колебалка 7 г',
  'item.lure_spoon_28': 'Колебалка 28 г',
  'item.lure_spinner_3': 'Вертушка 3 г',
  'item.lure_spinner_14': 'Вертушка 14 г',
  'item.lure_minnow_90': 'Воблер-минноу 90 мм',
  'item.lure_crank_60': 'Воблер-кренк 60 мм',
  'item.lure_shad_70': 'Воблер-шэд 70 мм',
  'item.lure_popper_80': 'Поппер 80 мм',
  'item.lure_walker_95': 'Волкер 95 мм',
  'item.lure_jerk_130': 'Джеркбейт 130 мм',
  'item.lure_swim_150': 'Свимбейт составной 150 мм',
  'item.lure_jighead_12': 'Джиг-головка 12 г',
  'item.lure_sil_worm': 'Силиконовый червь',
  'item.lure_sil_shad': 'Силиконовый виброхвост',
  'item.lure_sil_twister': 'Силиконовый твистер',
  'item.lure_mandula': 'Мандула',
  'item.lure_fly_wet': 'Мушка мокрая',
  'item.lure_fly_dry': 'Мушка сухая',

  // ── наживка ──
  'item.bait_bloodworm': 'Мотыль',
  'item.bait_barley': 'Перловка',
  'item.bait_dough': 'Тесто',
  'item.bait_peas': 'Горох',
  'item.bait_boilie': 'Бойлы',
  'item.bait_pellets': 'Пеллетс',
  'item.bait_mussel': 'Ракушка речная',
  'item.bait_shrimp': 'Рачок-бокоплав',
  'item.bait_bread': 'Хлебный мякиш',
  'item.bait_cheese': 'Сыр',

  // ── прикормка ──
  'item.gb_bream': 'Прикормка «Лещ»',
  'item.gb_carp': 'Прикормка «Карп»',
  'item.gb_roach': 'Прикормка «Плотва»',
  'item.gb_feeder': 'Прикормка фидерная',
  'item.gb_winter': 'Прикормка зимняя',
  'item.gb_dip': 'Ароматизатор-дип',
  'item.gb_pva': 'ПВА-мешки',
  'item.gb_soil': 'Грунт для прикормки',

  // ── еда ──
  'item.food_soup': 'Котелок с ухой',
  'item.food_coffee': 'Кофе',
  'item.food_energy': 'Энергетик',
  'item.food_bar': 'Батончик',

  // ── садки ──
  'item.keep_60': 'Садок 60 см',
  'item.keep_cage': 'Садок прорезиненный',
  'item.keep_sack': 'Мешок карповый',

  // ── эхолоты ──
  'item.sonar_wireless': 'Эхолот беспроводной',
  'item.sonar_color': 'Эхолот цветной с картой',
  'item.sonar_ice': 'Эхолот зимний',

  // ── лодки ──
  'item.boat_pvc': 'Лодка надувная ПВХ',
  'item.boat_outboard': 'Мотор подвесной',
  'item.boat_mount': 'Крепление эхолота',
  'item.boat_anchor': 'Якорь лодочный',

  // ── снаряжение ──
  'item.gear_forceps': 'Экстрактор',
  'item.gear_pliers': 'Плоскогубцы рыболовные',
  'item.gear_mat': 'Мат карповый',
  'item.gear_rodpod': 'Род-под',
  'item.gear_umbrella': 'Зонт рыболовный',
  'item.gear_bag': 'Сумка для снастей',
  'item.gear_bucket': 'Ведро для прикормки',
  'item.gear_polar': 'Очки поляризационные',

  // ── нахлыст: вторая сотня видов ──
  'item.fly_line_5': 'Нахлыстовый шнур 5 класса',
  'item.fly_line_8': 'Нахлыстовый шнур 8 класса',
  'item.fly_backing': 'Бэкинг нахлыстовый',
  'item.fly_tippet': 'Поводковый материал',
  'item.fly_box': 'Коробка для мушек',
  'item.fly_dry_set': 'Набор сухих мушек',
  'item.fly_wet_set': 'Набор мокрых мушек',
  'item.fly_nymph_set': 'Набор нимф',
  'item.fly_streamer': 'Стример',
  'item.fly_hegene': 'Гирлянда нимф',
  'item.fly_floatant': 'Флотант',
  'item.fly_sink': 'Паста для утопления',
  'item.fly_vice': 'Тиски для вязания мушек',

  // ── наживка: вторая сотня видов ──
  'item.bait_caddis': 'Личинка ручейника',
  'item.bait_roe': 'Икра лососёвая',
  'item.bait_cut': 'Резка рыбы',
  'item.bait_grasshopper': 'Кузнечик',
  'item.bait_algae': 'Нитчатые водоросли',
  'item.bait_frog': 'Лягушка',
  'item.bait_fruit': 'Фрукты',
  'item.bait_meat': 'Мясо',
  'item.bait_mussel_tropic': 'Ракушка речная крупная',

  // ── поводки: вторая сотня видов ──
  'item.lead_wire_20': 'Поводок стальной 20 кг',
  'item.lead_wire_40': 'Поводок стальной 40 кг',
  'item.lead_shock_heavy': 'Ударный поводок 60 кг',
  'item.lead_mono_heavy': 'Поводок монофильный 1,0 мм',

  // ── крючки: вторая сотня видов ──
  'item.hook_3_0': 'Крючок № 3/0',
  'item.hook_6_0': 'Крючок № 6/0',
  'item.hook_circle': 'Крючок круглый',
  'item.hook_fly': 'Крючок нахлыстовый',

  // ── снаряжение: вторая сотня видов ──
  'item.gear_waders': 'Забродный костюм',
  'item.gear_boots': 'Забродные ботинки',
  'item.gear_glove': 'Перчатка для трофея',
  'item.gear_lipgrip': 'Захват для рыбы',
  'item.gear_gaff': 'Багор',
  'item.gear_cooler': 'Термосумка',
  'item.gear_repellent': 'Средство от гнуса',
  'item.gear_marker': 'Маркерный поплавок',

  'item.float_light_1g': "Поплавок лёгкий 1 г",
  'item.float_mid_3g': "Поплавок средний 3 г",
  'item.float_heavy_6g': "Поплавок тяжёлый 6 г",

  'item.float_quill_05': 'Поплавок-перо 0,5 г',
  'item.float_waggler_4g': 'Вагглер 4 г',
  'item.float_slider_8g': 'Поплавок скользящий 8 г',
  'item.rod_pole_90': 'Удилище штекерное 9,00 м',
};
